import { FC } from "react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

interface AccountAvatarProps {
	name: string | null | undefined;
	iconClass?: string;
}

export const AccountAvatar: FC<AccountAvatarProps> = ({ name, iconClass = "bg-blue-100" }) => {
	if (!name) {
		return null;
	}
	const initials = name.slice(0, 2);
	return (
		<div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
			<Avatar className="h-8 w-8 rounded-lg">
				<AvatarFallback className={`rounded-lg ${iconClass}`}>{initials}</AvatarFallback>
			</Avatar>
			<div className="grid flex-1 text-left text-sm leading-tight">
				<span className="truncate font-medium">{name}</span>
			</div>
		</div>
	);
};
